module.exports = "<span>\n    <img src='/img/ajax-loader.gif' />\n    <span ng-if='!hideText'> {{text || 'Loading ...'}}</span>\n</span>\n";